<template>
  <ChartNormal
    size="12"
    offset="0"
    title="End Of Life"
    chart="column"
    chartType="EOL"
    :isCity="false"
    :withDate="true"
    :withFinancial="false"
  />
</template>

<script>
import ChartNormal from "../../../components/chart/chartNormal";

export default {
  name: "EndOfLife",
  components: {
    ChartNormal
  }
};
</script>
